import React from 'react';

import LoginTitle from 'app/login/components/LoginTitle';
import ZapPreview from 'app/dashboard/components/ZapPreview';

const disabledMessages = {
  login: 'Log in first to turn on this Zap!',
  'sign-up': 'Sign up first to turn on this Zap!',
};

const titles = {
  login: 'Log in to turn on this Zap',
  'sign-up': 'Sign up to turn on this Zap',
};

const LoginPreview = ({ params, previewType }) => (
  <div>
    <LoginTitle>{titles[previewType]}</LoginTitle>
    {params.szid ? (
      <ZapPreview
        disabledMessage={disabledMessages[previewType]}
        zapId={params.szid}
      />
    ) : null}
  </div>
);

export default LoginPreview;
